import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslate } from "../i18n";
import { renderCategoryIcon } from "../components/categoryIcons";

const CAT_COLORS = [
  "#6366f1",
  "#7c3aed",
  "#0891b2",
  "#059669",
  "#d97706",
  "#db2777",
  "#ea580c",
  "#2563eb",
];

export default function SidebarCategoryNavItem({
  cat,
  idx,
  collapsed,
  currentPath,
  onClick,
}) {
  const path = `/${cat.slug}`;
  const active =
    currentPath === path || (path !== "/" && currentPath.startsWith(path));
  const [hov, setHov] = useState(false);
  const { t } = useTranslate();
  const label = t(cat.translationKey || cat.title);
  const color = CAT_COLORS[idx % CAT_COLORS.length];

  return (
    <Link
      to={path}
      onClick={onClick}
      className="e-touch-target"
      title={collapsed ? label : undefined}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: collapsed ? "10px 14px" : "9px 12px",
        minHeight: 38,
        borderRadius: 8,
        textDecoration: "none",
        background: active
          ? "var(--accent-g)"
          : hov
            ? "var(--hover-bg)"
            : "transparent",
        color: active ? "var(--text)" : "var(--muted2)",
        fontWeight: active ? 600 : 400,
        fontSize: 13,
        transition: "all 0.15s",
        whiteSpace: "nowrap",
        overflow: "hidden",
      }}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
    >
      <span
        style={{
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          color: active || hov ? color : color + "bb",
          transition: "color 0.15s",
        }}
      >
        {renderCategoryIcon(cat.icon, { size: 16 })}
      </span>
      {!collapsed && (
        <span style={{ overflow: "hidden", textOverflow: "ellipsis", flex: 1 }}>
          {label}
        </span>
      )}
      {!collapsed && active && (
        <span
          style={{
            width: 4,
            height: 4,
            borderRadius: 2,
            background: color,
            flexShrink: 0,
          }}
        />
      )}
    </Link>
  );
}
